import React from 'react';

export default function ProcurementApprovalsTableHeadTile(props) {
    return (
        <div className="tw-basis-3/12 table__card tw-mx-3 tw-bg-blue-25">
            <h4>{props.text}</h4>
        </div>
    );
}
